import styled from "styled-components";
import React from "react";
import {FlexMinHeightContent, FlexColumnCenter} from "../components/StyleComponents";
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField
} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import {Formik, FormikActions} from "formik";
import getConfigSchema from "../validation-schemas/config-schema";
import {debounce} from 'ts-debounce';
import Loader from "../components/Loader";
import {withSnackbar} from "notistack";
import {computed} from "mobx";
import i18n from "i18next";


const CampaignConfigFormWrapperStyled = styled(FlexColumnCenter)`
    width: 100%;    
    max-width: 700px;
    margin: 0 auto;
    border-radius: 3px;
    background: white;
    
    h1{
        margin: 0;
    padding: 19px 15px 10px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    }
    h3{
    margin-top: 0;
    font-weight: 500;
    text-align: center;
    color: rgba(0,0,0,.54);
    margin-bottom: 16px;
    font-size: 16px;
    position: relative;
    :after{
        content: ' ';
        position: absolute;
        bottom: -14px;
        height: 1px;
        width: 57%;
        background: #2f89fc;
        right: 0;
        left: 0;
        margin: 0 auto;
      }
    }
    
    h4{
      font-size: 17px;
      font-weight: 500;
      text-align: ${(props: any) => props.uiStore.isRTL ? 'right' : 'left'};
      padding-left: 54px;
      margin-bottom: 31px;
    }
    
    form{
         padding:  0 40px 40px;
    }
    
    ul{
        padding: 0 23px;
    }
`;
const UlStyled = styled.ul`
        padding: 0;
        margin-bottom: 30px;
        text-align: left;
        counter-reset: section;
        list-style: none;
    li{
        position: relative;

        min-height: 59px;
        flex-wrap: wrap;
        flex: 1;
        padding-right: 21px;
        &:first-child{
        border-bottom: 1px solid #dbdbdb;
                padding-bottom: 45px;
        margin-bottom: 50px;
    }
    }
    
    li::before {
        counter-increment: section;
        content: counter(section);
        border: 2px solid #1c4bc3;
        border-radius: 30px;
        width: 35px;
        height: 35px;
        text-align: center;
        margin-right: 16px;
        position: absolute;
        top: -10px;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 19px;
        font-weight: bold;
        color: #1c4bc3;
        line-height: 19px;
        
}
`;
const CustomSelect = ({items, value, onChange, error, label, name}: any) => {

    // #TODO set interface to items like label, value
    const menuItems = items.map((item: any, index: number) => {
        return (
            <MenuItem value={item.id || index}
                      key={item.key || item.id}>{item.displayName || item.name || item.title}
            </MenuItem>
        )
    });

    value = typeof value !== "undefined" ? value : '';

    menuItems.splice(0, 0, (
        <MenuItem value='' key={Math.random()}>
            <em>None</em>
        </MenuItem>)
    );


    // const inputLabel = React.useRef<any>(null);
    // const [labelWidth, setLabelWidth] = React.useState(0);
    // React.useEffect(() => {
    //     setLabelWidth(inputLabel.current!.offsetWidth);
    // }, []);

    // menuItems.splice(0, 0, (<MenuItem key={'None'} value=""><em>None</em></MenuItem>));
    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel htmlFor={name}>
                {label}
            </InputLabel>
            <Select
                error={typeof error !== "undefined"}
                value={value}
                onChange={onChange}
                input={
                    <OutlinedInput
                        labelWidth={90}
                        name={name}
                        id={name}/>
                }
            >
                {menuItems}
            </Select>
        </FormControl>
    );
};

interface ConfigFormValues {
    templateId: string;
    mailchimpListId: string;
    name: string;
    mailServiceFields: object;
}

@inject("templateStore", "campaignStore", "uiStore")
@observer
class CampaignConfig extends React.Component<any, any> {

    static whyDidYouRender = true;

    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            formDataHasChange: false,
        };
    }

    onUpdate = async (field: string, value: any, setFieldTouched: any) => {

        // const campaign = this.props.campaignStore.campaign;
        //
        // if (field.indexOf('.') > -1) {
        //     const [mailServiceFields, fieldName] = field.split('.');
        //     campaign[mailServiceFields][fieldName] = value;
        // } else {
        //     campaign[field] = value;
        // }

        setFieldTouched(field, true, true);
    };

    onUpdateDebounced = debounce(this.onUpdate, 400);

    onChange = async (event: any, setFieldValue: any, setFieldTouched: any, debounce = true) => {
        const {name, value} = event.target;

        setFieldValue(name, value);

        if (debounce) {
            event.persist();
            this.onUpdateDebounced(name, value, setFieldTouched);
        } else {
            this.onUpdate(name, value, setFieldTouched);
        }
    };

    setFieldTouched = (event: any, setFieldTouched: any) => {
        const {name} = event.target;
        setFieldTouched(name, true, true);
    };

    onSubmit = async (values: ConfigFormValues, {setSubmitting, resetForm}: FormikActions<ConfigFormValues>) => {
        const campaign = this.props.campaignStore.campaign;
        const templateId: number | undefined = values.templateId === '' ? undefined : Number(values.templateId);

        campaign.setTemplate(templateId);
        campaign.mailchimpListId = values.mailchimpListId;
        campaign.name = values.name;
        campaign.mailServiceFields = values.mailServiceFields;
        try {
            await this.save();
        } catch (e) {

        }
        setSubmitting(false);
        resetForm();
    };

    save = async () => {
        const campaign = this.props.campaignStore.campaign;

        this.setState({loading: true});
        try {
            try {
                await campaign.save();
            } catch (e) {

            }
            const key = this.props.enqueueSnackbar('Successfully saved.', {variant: 'success'});

            setTimeout(() => this.props.closeSnackbar(key), 2500);
        } catch (e) {
            const errorKey = this.props.enqueueSnackbar('Something went strangely, turning to the manager', {variant: 'error'});

            setTimeout(() => this.props.closeSnackbar(errorKey), 3000);
        }
        this.setState({loading: false});

        return;
    }

    onSelectTemplate = (id: number | '', setFieldTouched: any, setFieldValue: any) => {
        setFieldValue('templateId', id);
        setFieldTouched('templateId', true, true);
    }

    onSelectMailchimpList = (id: number | '', setFieldTouched: any, setFieldValue: any) => {
        setFieldValue('mailchimpListId', id);
        setFieldTouched('mailchimpListId', true, true);
    }

    @computed get initialValues() {

        const campaign = this.props.campaignStore.campaign;

        return {
            mailchimpListId: campaign.asJson.mailchimpListId ? campaign.asJson.mailchimpListId : '',
            name: campaign.asJson.name,
            mailServiceFields: campaign.asJson.mailServiceFields,
            templateId: campaign.asJson.template ? campaign.asJson.template.id : '',
        };
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const {
            campaignStore,
            templateStore
        } = this.props;

        return (
            <FlexMinHeightContent {...this.props} dir={this.props.uiStore.dir}>
                <Loader show={campaignStore.loadingData}/>
                <CampaignConfigFormWrapperStyled  {...this.props}>
                    <h1>{i18n.t('Campaign configuration')}</h1>
                    <h3>{i18n.t('Tell a bit about your campaign')}.</h3>

                    <span style={{display: "none"}}>
                                {this.state.loading ? 'LOADING' : 'NO'}
                        {JSON.stringify(campaignStore.mailchimpLists)}
                            </span>


                    <Formik
                        initialValues={this.initialValues}
                        validationSchema={getConfigSchema()}
                        validateOnChange={false}
                        enableReinitialize={true}
                        onSubmit={this.onSubmit}
                    >
                        {({
                              dirty,
                              isValid,
                              errors,
                              touched,
                              values,
                              setFieldValue,
                              setFieldTouched,
                              handleSubmit,
                          }: any) => {
                            return (
                                <form onSubmit={handleSubmit}>

                                            <span style={{display: "none"}}>
                                                  {JSON.stringify(errors.templateId)}
                                                {JSON.stringify(errors.mailchimpListId)}
                                                {JSON.stringify({isValid})}
                                            </span>
                                    <br/>
                                    <UlStyled>
                                        <li>
                                            <h4>
                                                {i18n.t('Campaign details')}
                                            </h4>
                                            <CustomSelect
                                                label={i18n.t('Template')}
                                                items={templateStore.templates}
                                                value={values.templateId}
                                                error={errors.templateId}
                                                name={'templateId'}
                                                onChange={(selected: any) => this.onSelectTemplate(selected.target.value, setFieldTouched, setFieldValue)}
                                            />
                                            <div style={{
                                                margin: '8px 12px 0',
                                                color: ' #f44336',
                                                fontSize: '0.75rem',
                                            }}>{errors.templateId}</div>
                                            <TextField
                                                label={i18n.t('Campaign name')}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                helperText={touched.name && errors.name && errors.name}
                                                error={touched.name && errors.name && !!errors.name}
                                                value={values.name}
                                                onChange={(event: any) => this.onChange(event, setFieldValue, setFieldTouched)}
                                                onBlur={(event: any) => this.setFieldTouched(event, setFieldTouched)}
                                                name='name'
                                                type='text'
                                            />
                                        </li>
                                        <li>
                                            <h4>
                                                {i18n.t('Mailchimp fields')}
                                            </h4>
                                            <CustomSelect
                                                label={i18n.t('Mailchimp list')}
                                                items={campaignStore.mailchimpLists}
                                                value={values.mailchimpListId}
                                                error={touched.mailchimpListId && errors.mailchimpListId}
                                                name={'mailchimpListId'}
                                                onChange={(selected: any) => this.onSelectMailchimpList(selected.target.value, setFieldTouched, setFieldValue)}
                                            />
                                            <div style={{
                                                margin: '8px 12px 0',
                                                color: ' #f44336',
                                                fontSize: '0.75rem',
                                            }}>{touched.mailchimpListId && errors.mailchimpListId}</div>
                                            <TextField
                                                label={i18n.t('Preview text')}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                helperText={touched.mailServiceFields && touched.mailServiceFields.preview && errors.mailServiceFields && errors.mailServiceFields.preview}
                                                error={touched.mailServiceFields && touched.mailServiceFields.preview && errors.mailServiceFields && !!errors.mailServiceFields.preview}
                                                value={values.mailServiceFields.preview}
                                                onChange={(event: any) => this.onChange(event, setFieldValue, setFieldTouched)}
                                                onBlur={(event: any) => this.setFieldTouched(event, setFieldTouched)}
                                                name='mailServiceFields.preview'
                                                type='text'
                                            />
                                            <TextField
                                                label={i18n.t('Title')}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                helperText={touched.mailServiceFields && touched.mailServiceFields.title && errors.mailServiceFields && errors.mailServiceFields.title}
                                                error={touched.mailServiceFields && touched.mailServiceFields.title && errors.mailServiceFields && !!errors.mailServiceFields.title}
                                                value={values.mailServiceFields.title}
                                                onChange={(event: any) => this.onChange(event, setFieldValue, setFieldTouched)}
                                                onBlur={(event: any) => this.setFieldTouched(event, setFieldTouched)}
                                                name='mailServiceFields.title'
                                                type='text'
                                            />
                                            <TextField
                                                label={i18n.t('Subject line')}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                helperText={touched.mailServiceFields && touched.mailServiceFields.subjectLine && errors.mailServiceFields && errors.mailServiceFields.subjectLine}
                                                error={touched.mailServiceFields && touched.mailServiceFields.subjectLine && errors.mailServiceFields && !!errors.mailServiceFields.subjectLine}
                                                value={values.mailServiceFields.subjectLine}
                                                onChange={(event: any) => this.onChange(event, setFieldValue, setFieldTouched)}
                                                onBlur={(event: any) => this.setFieldTouched(event, setFieldTouched)}
                                                name='mailServiceFields.subjectLine'
                                                type='text'
                                            />
                                            <TextField
                                                label={i18n.t('From')}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                helperText={touched.mailServiceFields && touched.mailServiceFields.from && errors.mailServiceFields && errors.mailServiceFields.from}
                                                error={touched.mailServiceFields && touched.mailServiceFields.from && errors.mailServiceFields && !!errors.mailServiceFields.from}
                                                value={values.mailServiceFields.from}
                                                onChange={(event: any) => this.onChange(event, setFieldValue, setFieldTouched)}
                                                onBlur={(event: any) => this.setFieldTouched(event, setFieldTouched)}
                                                name='mailServiceFields.from'
                                                type='text'
                                            />
                                            <TextField
                                                label={i18n.t('Replay to')}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                helperText={touched.mailServiceFields && touched.mailServiceFields.replayTo && errors.mailServiceFields && errors.mailServiceFields.replayTo}
                                                error={touched.mailServiceFields && touched.mailServiceFields.replayTo && errors.mailServiceFields && !!errors.mailServiceFields.replayTo}
                                                value={values.mailServiceFields.replayTo}
                                                onChange={(event: any) => this.onChange(event, setFieldValue, setFieldTouched)}
                                                onBlur={(event: any) => this.setFieldTouched(event, setFieldTouched)}
                                                name='mailServiceFields.replayTo'
                                                type='text'
                                            />


                                        </li>
                                    </UlStyled>


                                    <Button variant="contained"
                                            color="primary"
                                            size="large"
                                            type="submit"
                                            disabled={this.state.loading || !dirty || !isValid}
                                    >
                                        {this.state.loading && (
                                            <img
                                                alt='loading'
                                                src={process.env.NODE_ENV !== 'production' ? '/images/Dual_Ring-1s-200px-blue.svg' : '/wp-content/plugins/wp-campaigns/admin/partials/build/images/Dual_Ring-1s-200px-blue.svg'}
                                                width="20px"
                                                height="20px" style={{marginRight: 10}}/>)}
                                        {this.state.loading ? i18n.t('loading') : i18n.t('save button')}
                                    </Button>
                                </form>
                            )
                        }}
                    </Formik>
                </CampaignConfigFormWrapperStyled>
            </FlexMinHeightContent>
        );
    }
}

export default withSnackbar(CampaignConfig);

